import { render, staticRenderFns } from "./imgCollection.vue?vue&type=template&id=55d757a9&"
import script from "@viewJs/examRegisteation/imgCollection.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/imgCollection.js?vue&type=script&lang=js&"
import style0 from "./imgCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports